$(function() {
	//Oject Spread support IE11
	function ownKeys(object, enumerableOnly) {
		var keys = Object.keys(object);
		if (Object.getOwnPropertySymbols) {
			var symbols = Object.getOwnPropertySymbols(object);
			if (enumerableOnly) symbols = symbols.filter(function(sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; });
			keys.push.apply(keys, symbols);
		}
		return keys;
	}

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function(key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function(key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var form = {
		el: {
			body: $('body'),
			modal: $('.js-modal-meg'),
			modalContainer: $('.modal-meg__container'),
			form: $('.js-form'),
			message: $('.form-message'),
			emailNewsletter: $('.js-email'),
			emailModal: $('.js-email-filled'),
			checkbox: document.querySelectorAll('.js-checkbox')
		},
		fxInputEvents: function fxInputEvents() {
			this.el.checkbox.forEach(function(el) {
				return el.addEventListener('change', function(e) {
					return e.currentTarget.value = e.currentTarget.checked ? 'true' : 'false';
				});
			});
		},
		validations: function validations() {
			if (!this.el.form) return;
			var invalidFormatMessage = $('.js-form').attr('data-msg-invalidFormat');
			$('[name=birthDate]').prop('max', function() {
				return new Date().toJSON().split('T')[0];
			});
			$.validator.addMethod('date', function(value, el) {
				return this.optional(el) || /^(19\d\d|20[0-9]\d)-((0\d)|(1[012]))-(([012]\d)|3[01])$/.test(value);
			}, invalidFormatMessage);
			$.validator.addMethod('phone', function(value, el) {
				return this.optional(el) || /^(\+?)(?:[0-9] ?){8,11}[0-9]$/.test(value); // validate all phones
				//^(\+351|00351|351)?[2|3|9][0-9]{8}$ - validate all PT phones
				//^(\+351|00351|351)?[9][0-9]{8}$ - validate only all PT mobile phones
				//^(\+351|00351|351)?[2|3][0-9]{8}$ - validate only all PT landline phones
			}, invalidFormatMessage);
			$.validator.addMethod('email', function(value) {
				return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])+/i.test(value);
			}, invalidFormatMessage);
			$.validator.addMethod('zipcode-first', function(value, el) {
				return this.optional(el) || /^(\d{4})$/.test(value);
			}, invalidFormatMessage);
			$.validator.addMethod('zipcode-last', function(value, el) {
				return this.optional(el) || /^(\d{3})$/.test(value);
			}, invalidFormatMessage);
			$.validator.addMethod('nif', function(value) {
				//FIX IE for includes method
				if (!Array.prototype.includes) {
					Object.defineProperty(Array.prototype, 'includes', {
						enumerable: false,
						value: function value(obj) {
							var newArr = this.filter(function(el) {
								return el == obj;
							});
							return newArr.length > 0;
						}
					});
				}

				if (value += '', !['1', '2', '3', '5', '6', '8'].includes(value.substr(0, 1)) && !['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].includes(value.substr(0, 2))) return !1;
				var d,
					b = 9 * value[0] + 8 * value[1] + 7 * value[2] + 6 * value[3] + 5 * value[4] + 4 * value[5] + 3 * value[6] + 2 * value[7],
					c = b - 11 * parseInt(b / 11);
				return d = 1 == c || 0 == c ? 0 : 11 - c, value[8] == d;
			}, invalidFormatMessage);
		},
		fxFormToJson: function fxFormToJson(el) {
			var indexedArray = {};

			for (var i = 0; i < el.length; i++) {
				if (el[i].value) {
					if (['checkbox', 'radio'].indexOf(el[i].type) > -1 && el[i].checked || ['checkbox', 'radio', 'file', 'button'].indexOf(el[i].type) === -1) indexedArray[el[i].name] = el[i].value;
				}
			}

			return indexedArray;
		},
		events: function events() {
			var _this = this;

			if (!this.el.form) return;
			this.el.form.each(function(_, el) {
				$.validator.messages = _objectSpread(_objectSpread({}, $.validator.messages), {}, {
					required: el.dataset.msgRequired
				});
				$(el).validate({
					debug: true,
					errorElement: 'span',
					ignore: [],
					errorPlacement: function errorPlacement(error, element) {
						error.insertAfter(element.prop('type') == 'checkbox' ? element.next() : element);
						var formItem = $(element).closest(".muda-form-content");
						formItem.addClass("not-valid");
					},
					rules: {
						'howYouMetUsCompany': {
							required: {
								depends: function depends() {
									return document.querySelector('.js-toggle-select').value === 'Empresa' ? true : false;
								}
							}
						}
					},
					messages: {
						confirmPass: {
							equalTo: $(el).data('msg-equalto')
						}
					}
				});
				$(el).on('submit', function(e) {
					e.preventDefault();
					var target = $(e.currentTarget),
						isValid = target.valid(),
						allFields = JSON.stringify(_this.fxFormToJson(e.currentTarget));
					if (!isValid) return false;
					$.ajax({
						type: "POST",
						crossDomain: true,
						dataType: "json",
						contentType: 'application/json; charset=utf-8',
						url: target.data("endpoint"),
						data: allFields,
						beforeSend: function beforeSend() {
							target.find('.js-submit').attr('disabled', true).addClass('btn-loading');
							target.find('.btn-loading').append("<span class='btn-loading-spinner'></span>");
						}
					}).done(function(data, textStatus, jqXHR) {
						target.find('.js-submit').removeClass('btn-loading');
						target.find(".btn-loading-spinner").remove();

						if (jqXHR.status === 200) {
							var eventNewsletter = target.data('event-newsletter'),
								eventVolunteer = target.data('event-volunteer');
							if (eventNewsletter && typeof ga !== 'undefined') ga('send', 'event', 'Submit Form', eventNewsletter, 'submitted');
							if (eventVolunteer && typeof ga !== 'undefined') ga('send', 'event', 'Submit Form', eventVolunteer, 'submitted'); //if goes to modalmeg

							if (!target.hasClass('js-has-key') && data.key) {
								_this.el.modal.addClass('is-active').find('.js-key').val(data.key);
								_this.el.emailModal.val(_this.el.emailNewsletter.val());
								_this.el.body.css('overflow', 'hidden');
							} 
							//if is password
							else if (target.hasClass('form--password')) {
								target.fadeOut(200).siblings(':not(.form-message)').fadeOut(200);
								target.next().fadeIn(200);
							} // if is form data
							else if (target.hasClass('form-edit')) {
								target.find('input:not(".js-disabled-input"), select:not(".js-disabled-input"), textarea').each(function(_, el) {
									return $(el).attr('disabled', true);
								});
								target.find('.js-submit').fadeOut(200);
								target.next().fadeIn(200);
								setTimeout(function() {
									target.find('.js-submit').siblings().show();
									target.next().fadeOut(200);
								}, 5000);
							} // default
							else {
								// _this.el.message.text(data.resultMessage).show();
								// setTimeout(function() {
								// 	_this.el.message.text('')
								// }, 5000);

								_this.el.message.text(data).show();
								_this.el.modalContainer.hide();

							}

							_this.el.form.find('.js-submit').attr('disabled', false);
							_this.el.form.validate().resetForm();
							_this.el.form[0].reset();
						}
					}).fail(function(jqXHR) {
						target.find('.js-submit').attr('disabled', false).removeClass('btn-loading');
						target.find(".btn-loading-spinner").remove();
						if (jqXHR.responseJSON) {
							if (typeof jqXHR.responseJSON === 'object')
								JSON.parse(target.validate().showErrors(jqXHR.responseJSON));
							else {
								//form volunteer
								window.scroll(0, 0)
								JSON.parse(target.validate().showErrors({ 'name': jqXHR.responseJSON }));
							}
						}
					});
				});
			});
		},
		fxEnableForm: function fxEnableForm() {
			var _this2 = this;

			if (this.el.form.hasClass('form-edit')) {
				this.el.form.find('.js-enable-form').on('click', function(e) {
					$(e.currentTarget).hide().next().hide();
					_this2.el.form.find('.js-submit').show();
					_this2.el.form.find('input:not(.js-disabled-input):not(.disabled), select:not(.js-disabled-input), textarea').each(function(_, el) {
						return $(el).attr('disabled', false);
					});
				});
			}
		},
		init: function init() {
			this.fxInputEvents();
			this.validations();
			this.events();
			this.fxEnableForm();
		}
	};
	form.init();
});